import { sql } from 'drizzle-orm'

export const migrate0003 = sql`ALTER TABLE \`action\` ADD \`csvId\` integer REFERENCES accountCsv(id);--> statement-breakpoint
CREATE INDEX \`idx_action_csvId\` ON \`action\` (\`csvId\`);--> statement-breakpoint
UPDATE \`action\`
SET \`csvId\` = (
    SELECT \`actionCsvRelation\`.\`csvId\`
    FROM \`actionCsvRelation\`
    WHERE \`actionCsvRelation\`.\`actionId\` = \`action\`.\`id\`
    LIMIT 1
)
WHERE EXISTS (
    SELECT 1
    FROM \`actionCsvRelation\`
    WHERE \`actionCsvRelation\`.\`actionId\` = \`action\`.\`id\`
);
--> statement-breakpoint
DROP TABLE \`actionCsvRelation\`;--> statement-breakpoint
PRAGMA foreign_keys=OFF;--> statement-breakpoint
CREATE TABLE \`__new_accountCsv\` (
	\`id\` integer PRIMARY KEY AUTOINCREMENT NOT NULL,
	\`accountId\` integer NOT NULL,
	\`csvId\` text NOT NULL,
	\`csvName\` text NOT NULL,
	FOREIGN KEY (\`accountId\`) REFERENCES \`account\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
--> statement-breakpoint
INSERT INTO \`__new_accountCsv\`("id", "accountId", "csvId", "csvName") SELECT "id", "accountId", "csvId", "csvName" FROM \`accountCsv\`;--> statement-breakpoint
DROP TABLE \`accountCsv\`;--> statement-breakpoint
ALTER TABLE \`__new_accountCsv\` RENAME TO \`accountCsv\`;--> statement-breakpoint
CREATE INDEX \`unq_accountCsv_accountId\` ON \`accountCsv\` (\`accountId\`);--> statement-breakpoint
CREATE TABLE \`__new_accountErc20TokenRelation\` (
	\`accountId\` integer NOT NULL,
	\`tokenId\` text NOT NULL,
	FOREIGN KEY (\`accountId\`) REFERENCES \`account\`(\`id\`) ON UPDATE no action ON DELETE cascade,
	FOREIGN KEY (\`tokenId\`) REFERENCES \`erc20Token\`(\`id\`) ON UPDATE no action ON DELETE no action
);
--> statement-breakpoint
INSERT INTO \`__new_accountErc20TokenRelation\`("accountId", "tokenId") SELECT "accountId", "tokenId" FROM \`accountErc20TokenRelation\`;--> statement-breakpoint
DROP TABLE \`accountErc20TokenRelation\`;--> statement-breakpoint
ALTER TABLE \`__new_accountErc20TokenRelation\` RENAME TO \`accountErc20TokenRelation\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_accountErc20TokenRelation\` ON \`accountErc20TokenRelation\` (\`accountId\`,\`tokenId\`);--> statement-breakpoint
CREATE TABLE \`__new_accountEvmCsv\` (
	\`accountId\` integer NOT NULL,
	\`csvId\` text NOT NULL,
	\`order\` integer NOT NULL,
	\`fileName\` text NOT NULL,
	\`hashCount\` integer NOT NULL,
	\`from\` integer NOT NULL,
	\`to\` integer NOT NULL,
	FOREIGN KEY (\`accountId\`) REFERENCES \`account\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
--> statement-breakpoint
INSERT INTO \`__new_accountEvmCsv\`("accountId", "csvId", "order", "fileName", "hashCount", "from", "to") SELECT "accountId", "csvId", "order", "fileName", "hashCount", "from", "to" FROM \`accountEvmCsv\`;--> statement-breakpoint
DROP TABLE \`accountEvmCsv\`;--> statement-breakpoint
ALTER TABLE \`__new_accountEvmCsv\` RENAME TO \`accountEvmCsv\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`unq_accountEvmCsv\` ON \`accountEvmCsv\` (\`accountId\`,\`csvId\`,\`order\`);--> statement-breakpoint
CREATE TABLE \`__new_accountEvmTxIndexRelation\` (
	\`accountId\` integer NOT NULL,
	\`hash\` blob NOT NULL,
	\`analyzed\` integer NOT NULL,
	FOREIGN KEY (\`accountId\`) REFERENCES \`account\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
--> statement-breakpoint
INSERT INTO \`__new_accountEvmTxIndexRelation\`("accountId", "hash", "analyzed") SELECT "accountId", "hash", "analyzed" FROM \`accountEvmTxIndexRelation\`;--> statement-breakpoint
DROP TABLE \`accountEvmTxIndexRelation\`;--> statement-breakpoint
ALTER TABLE \`__new_accountEvmTxIndexRelation\` RENAME TO \`accountEvmTxIndexRelation\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_accountEvmTxIndexRelation\` ON \`accountEvmTxIndexRelation\` (\`accountId\`,\`hash\`);--> statement-breakpoint
CREATE TABLE \`__new_accountExchangeApi\` (
	\`accountId\` integer NOT NULL,
	\`apiId\` text NOT NULL,
	\`from\` integer NOT NULL,
	\`to\` integer NOT NULL,
	FOREIGN KEY (\`accountId\`) REFERENCES \`account\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
--> statement-breakpoint
INSERT INTO \`__new_accountExchangeApi\`("accountId", "apiId", "from", "to") SELECT "accountId", "apiId", "from", "to" FROM \`accountExchangeApi\`;--> statement-breakpoint
DROP TABLE \`accountExchangeApi\`;--> statement-breakpoint
ALTER TABLE \`__new_accountExchangeApi\` RENAME TO \`accountExchangeApi\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`unq_accountExchangeApi\` ON \`accountExchangeApi\` (\`accountId\`,\`apiId\`);--> statement-breakpoint
CREATE TABLE \`__new_accountPolkadotExtrinsicRelation\` (
	\`accountId\` integer NOT NULL,
	\`blockNumber\` integer NOT NULL,
	\`extrinsicIndex\` integer,
	\`analyzed\` integer NOT NULL,
	FOREIGN KEY (\`accountId\`) REFERENCES \`account\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
--> statement-breakpoint
INSERT INTO \`__new_accountPolkadotExtrinsicRelation\`("accountId", "blockNumber", "extrinsicIndex", "analyzed") SELECT "accountId", "blockNumber", "extrinsicIndex", "analyzed" FROM \`accountPolkadotExtrinsicRelation\`;--> statement-breakpoint
DROP TABLE \`accountPolkadotExtrinsicRelation\`;--> statement-breakpoint
ALTER TABLE \`__new_accountPolkadotExtrinsicRelation\` RENAME TO \`accountPolkadotExtrinsicRelation\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_accountPolkadotExtrinsicRelation\` ON \`accountPolkadotExtrinsicRelation\` (\`accountId\`,\`blockNumber\`,\`extrinsicIndex\`);--> statement-breakpoint
CREATE TABLE \`__new_accountSolanaSignature\` (
	\`accountId\` integer NOT NULL,
	\`signature\` text NOT NULL,
	\`analyzed\` integer NOT NULL,
	FOREIGN KEY (\`accountId\`) REFERENCES \`account\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
--> statement-breakpoint
INSERT INTO \`__new_accountSolanaSignature\`("accountId", "signature", "analyzed") SELECT "accountId", "signature", "analyzed" FROM \`accountSolanaSignature\`;--> statement-breakpoint
DROP TABLE \`accountSolanaSignature\`;--> statement-breakpoint
ALTER TABLE \`__new_accountSolanaSignature\` RENAME TO \`accountSolanaSignature\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_accountSolanaSignature\` ON \`accountSolanaSignature\` (\`accountId\`,\`signature\`);--> statement-breakpoint
CREATE TABLE \`__new_accountingTransaction\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`accountingPeriodId\` integer NOT NULL,
	\`actionId\` text NOT NULL,
	\`order\` integer NOT NULL,
	\`category\` text NOT NULL,
	\`subCategory\` text,
	\`targetId\` text,
	\`timestamp\` integer NOT NULL,
	\`comment\` text,
	\`updatedAt\` integer NOT NULL,
	FOREIGN KEY (\`accountingPeriodId\`) REFERENCES \`accountingPeriod\`(\`id\`) ON UPDATE no action ON DELETE cascade,
	FOREIGN KEY (\`actionId\`) REFERENCES \`action\`(\`id\`) ON UPDATE no action ON DELETE cascade,
	FOREIGN KEY (\`targetId\`) REFERENCES \`nft\`(\`id\`) ON UPDATE no action ON DELETE no action
);
--> statement-breakpoint
INSERT INTO \`__new_accountingTransaction\`("id", "accountingPeriodId", "actionId", "order", "category", "subCategory", "targetId", "timestamp", "comment", "updatedAt") SELECT "id", "accountingPeriodId", "actionId", "order", "category", "subCategory", "targetId", "timestamp", "comment", "updatedAt" FROM \`accountingTransaction\`;--> statement-breakpoint
DROP TABLE \`accountingTransaction\`;--> statement-breakpoint
ALTER TABLE \`__new_accountingTransaction\` RENAME TO \`accountingTransaction\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_accountingTransaction\` ON \`accountingTransaction\` (\`actionId\`,\`order\`);--> statement-breakpoint
CREATE INDEX \`idx_accountingTransaction_accountingPeriodId\` ON \`accountingTransaction\` (\`accountingPeriodId\`);--> statement-breakpoint
CREATE TABLE \`__new_accountingTransactionTransfer\` (
	\`transactionId\` text NOT NULL,
	\`order\` integer NOT NULL,
	\`isIn\` integer NOT NULL,
	\`cryptoId\` text,
	\`fiatId\` text,
	\`nftId\` text,
	\`amount\` text NOT NULL,
	\`price\` text NOT NULL,
	\`zeroCompleted\` integer NOT NULL,
	\`cost\` text NOT NULL,
	\`balance\` text NOT NULL,
	\`borrowing\` text NOT NULL,
	\`totalPl\` text NOT NULL,
	\`tradePl\` text NOT NULL,
	\`incomePl\` text NOT NULL,
	\`feePl\` text NOT NULL,
	FOREIGN KEY (\`transactionId\`) REFERENCES \`accountingTransaction\`(\`id\`) ON UPDATE no action ON DELETE cascade,
	FOREIGN KEY (\`cryptoId\`) REFERENCES \`cryptoCurrency\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`nftId\`) REFERENCES \`nft\`(\`id\`) ON UPDATE no action ON DELETE no action
);
--> statement-breakpoint
INSERT INTO \`__new_accountingTransactionTransfer\`("transactionId", "order", "isIn", "cryptoId", "fiatId", "nftId", "amount", "price", "zeroCompleted", "cost", "balance", "borrowing", "totalPl", "tradePl", "incomePl", "feePl") SELECT "transactionId", "order", "isIn", "cryptoId", "fiatId", "nftId", "amount", "price", "zeroCompleted", "cost", "balance", "borrowing", "totalPl", "tradePl", "incomePl", "feePl" FROM \`accountingTransactionTransfer\`;--> statement-breakpoint
DROP TABLE \`accountingTransactionTransfer\`;--> statement-breakpoint
ALTER TABLE \`__new_accountingTransactionTransfer\` RENAME TO \`accountingTransactionTransfer\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_accountingTransactionTransfer\` ON \`accountingTransactionTransfer\` (\`transactionId\`,\`order\`);--> statement-breakpoint
CREATE TABLE \`__new_actionAccountRelation\` (
	\`actionId\` text NOT NULL,
	\`accountId\` integer NOT NULL,
	FOREIGN KEY (\`actionId\`) REFERENCES \`action\`(\`id\`) ON UPDATE no action ON DELETE cascade,
	FOREIGN KEY (\`accountId\`) REFERENCES \`account\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
--> statement-breakpoint
INSERT INTO \`__new_actionAccountRelation\`("actionId", "accountId") SELECT "actionId", "accountId" FROM \`actionAccountRelation\`;--> statement-breakpoint
DROP TABLE \`actionAccountRelation\`;--> statement-breakpoint
ALTER TABLE \`__new_actionAccountRelation\` RENAME TO \`actionAccountRelation\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_actionAccountRelation\` ON \`actionAccountRelation\` (\`actionId\`,\`accountId\`);--> statement-breakpoint
CREATE INDEX \`idx_actionAccountRelation_accountId\` ON \`actionAccountRelation\` (\`accountId\`);--> statement-breakpoint
CREATE TABLE \`__new_action\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`sourceId\` text NOT NULL,
	\`order\` integer NOT NULL,
	\`type\` text NOT NULL,
	\`evidence\` text NOT NULL,
	\`timestamp\` integer NOT NULL,
	\`comment\` text,
	\`app\` text,
	\`loanId\` text,
	\`crossId\` text,
	\`crossType\` text,
	\`targetId\` text,
	\`locked\` integer NOT NULL,
	\`generatedTx\` integer NOT NULL,
	\`relatedAssetIds\` text,
	\`fromAddresses\` text,
	\`toAddresses\` text,
	\`hasUnknownPriceTx\` integer,
	\`hasInsufficientAmountTx\` integer,
	\`csvId\` integer,
	FOREIGN KEY (\`sourceId\`) REFERENCES \`actionSource\`(\`id\`) ON UPDATE no action ON DELETE cascade,
	FOREIGN KEY (\`targetId\`) REFERENCES \`nft\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`csvId\`) REFERENCES \`accountCsv\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
--> statement-breakpoint
INSERT INTO \`__new_action\`("id", "sourceId", "order", "type", "evidence", "timestamp", "comment", "app", "loanId", "crossId", "crossType", "targetId", "locked", "generatedTx", "relatedAssetIds", "fromAddresses", "toAddresses", "hasUnknownPriceTx", "hasInsufficientAmountTx", "csvId") SELECT "id", "sourceId", "order", "type", "evidence", "timestamp", "comment", "app", "loanId", "crossId", "crossType", "targetId", "locked", "generatedTx", "relatedAssetIds", "fromAddresses", "toAddresses", "hasUnknownPriceTx", "hasInsufficientAmountTx", "csvId" FROM \`action\`;--> statement-breakpoint
DROP TABLE \`action\`;--> statement-breakpoint
ALTER TABLE \`__new_action\` RENAME TO \`action\`;--> statement-breakpoint
CREATE INDEX \`idx_action\` ON \`action\` (\`sourceId\`,\`order\`,\`type\`,\`evidence\`,\`timestamp\`,\`app\`,\`targetId\`,\`locked\`,\`relatedAssetIds\`,\`fromAddresses\`,\`toAddresses\`,\`hasUnknownPriceTx\`,\`hasInsufficientAmountTx\`);--> statement-breakpoint
CREATE INDEX \`idx_action_type\` ON \`action\` (\`type\`);--> statement-breakpoint
CREATE INDEX \`idx_action_evidence\` ON \`action\` (\`evidence\`);--> statement-breakpoint
CREATE INDEX \`idx_action_timestamp\` ON \`action\` (\`timestamp\`);--> statement-breakpoint
CREATE INDEX \`idx_action_app\` ON \`action\` (\`app\`);--> statement-breakpoint
CREATE INDEX \`targetIdIdx\` ON \`action\` (\`targetId\`);--> statement-breakpoint
CREATE INDEX \`idx_action_locked\` ON \`action\` (\`locked\`);--> statement-breakpoint
CREATE INDEX \`idx_action_relatedAssetIds\` ON \`action\` (\`relatedAssetIds\`);--> statement-breakpoint
CREATE INDEX \`idx_action_fromAddresses\` ON \`action\` (\`fromAddresses\`);--> statement-breakpoint
CREATE INDEX \`idx_action_toAddresses\` ON \`action\` (\`toAddresses\`);--> statement-breakpoint
CREATE INDEX \`idx_action_hasUnknownPriceTx\` ON \`action\` (\`hasUnknownPriceTx\`);--> statement-breakpoint
CREATE INDEX \`idx_action_hasInsufficientAmountTx\` ON \`action\` (\`hasInsufficientAmountTx\`);--> statement-breakpoint
CREATE INDEX \`idx_action_csvId\` ON \`action\` (\`csvId\`);--> statement-breakpoint
CREATE TABLE \`__new_actionTransfer\` (
	\`actionId\` text NOT NULL,
	\`order\` integer NOT NULL,
	\`direction\` text NOT NULL,
	\`from\` text,
	\`to\` text,
	\`cryptoId\` text,
	\`fiatId\` text,
	\`nftId\` text,
	\`amount\` text NOT NULL,
	\`price\` text,
	FOREIGN KEY (\`actionId\`) REFERENCES \`action\`(\`id\`) ON UPDATE no action ON DELETE cascade,
	FOREIGN KEY (\`cryptoId\`) REFERENCES \`cryptoCurrency\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`nftId\`) REFERENCES \`nft\`(\`id\`) ON UPDATE no action ON DELETE no action
);
--> statement-breakpoint
INSERT INTO \`__new_actionTransfer\`("actionId", "order", "direction", "from", "to", "cryptoId", "fiatId", "nftId", "amount", "price") SELECT "actionId", "order", "direction", "from", "to", "cryptoId", "fiatId", "nftId", "amount", "price" FROM \`actionTransfer\`;--> statement-breakpoint
DROP TABLE \`actionTransfer\`;--> statement-breakpoint
ALTER TABLE \`__new_actionTransfer\` RENAME TO \`actionTransfer\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_actionTransfer\` ON \`actionTransfer\` (\`actionId\`,\`order\`);--> statement-breakpoint
CREATE TABLE \`__new_assetBalanceHistory\` (
	\`accountingId\` integer NOT NULL,
	\`key\` text NOT NULL,
	\`day\` integer NOT NULL,
	\`hour\` integer NOT NULL,
	\`cryptoId\` text,
	\`fiatId\` text,
	\`amount\` text NOT NULL,
	\`price\` text,
	\`timestamp\` integer NOT NULL,
	FOREIGN KEY (\`accountingId\`) REFERENCES \`account\`(\`id\`) ON UPDATE no action ON DELETE cascade,
	FOREIGN KEY (\`cryptoId\`) REFERENCES \`cryptoCurrency\`(\`id\`) ON UPDATE no action ON DELETE no action
);
--> statement-breakpoint
INSERT INTO \`__new_assetBalanceHistory\`("accountingId", "key", "day", "hour", "cryptoId", "fiatId", "amount", "price", "timestamp") SELECT "accountingId", "key", "day", "hour", "cryptoId", "fiatId", "amount", "price", "timestamp" FROM \`assetBalanceHistory\`;--> statement-breakpoint
DROP TABLE \`assetBalanceHistory\`;--> statement-breakpoint
ALTER TABLE \`__new_assetBalanceHistory\` RENAME TO \`assetBalanceHistory\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_assetBalanceHistory\` ON \`assetBalanceHistory\` (\`accountingId\`,\`key\`,\`day\`,\`hour\`,\`cryptoId\`,\`fiatId\`);--> statement-breakpoint
CREATE TABLE \`__new_assetBalance\` (
	\`accountingPeriodId\` integer NOT NULL,
	\`asset\` text NOT NULL,
	\`order\` integer NOT NULL,
	\`value\` text NOT NULL,
	\`amount\` text NOT NULL,
	FOREIGN KEY (\`accountingPeriodId\`) REFERENCES \`accountingPeriod\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
--> statement-breakpoint
INSERT INTO \`__new_assetBalance\`("accountingPeriodId", "asset", "order", "value", "amount") SELECT "accountingPeriodId", "asset", "order", "value", "amount" FROM \`assetBalance\`;--> statement-breakpoint
DROP TABLE \`assetBalance\`;--> statement-breakpoint
ALTER TABLE \`__new_assetBalance\` RENAME TO \`assetBalance\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_assetBalance\` ON \`assetBalance\` (\`accountingPeriodId\`,\`asset\`,\`order\`);--> statement-breakpoint
CREATE TABLE \`__new_assetBorrow\` (
	\`accountingPeriodId\` integer NOT NULL,
	\`asset\` text NOT NULL,
	\`order\` integer NOT NULL,
	\`value\` text NOT NULL,
	\`amount\` text NOT NULL,
	\`borrowedValue\` text NOT NULL,
	\`borrowedAmount\` text NOT NULL,
	FOREIGN KEY (\`accountingPeriodId\`) REFERENCES \`accountingPeriod\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
--> statement-breakpoint
INSERT INTO \`__new_assetBorrow\`("accountingPeriodId", "asset", "order", "value", "amount", "borrowedValue", "borrowedAmount") SELECT "accountingPeriodId", "asset", "order", "value", "amount", "borrowedValue", "borrowedAmount" FROM \`assetBorrow\`;--> statement-breakpoint
DROP TABLE \`assetBorrow\`;--> statement-breakpoint
ALTER TABLE \`__new_assetBorrow\` RENAME TO \`assetBorrow\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_assetBorrow\` ON \`assetBorrow\` (\`accountingPeriodId\`,\`asset\`,\`order\`);--> statement-breakpoint
CREATE TABLE \`__new_assetValue\` (
	\`accountingPeriodId\` integer NOT NULL,
	\`asset\` text NOT NULL,
	\`type\` text NOT NULL,
	\`amount\` text NOT NULL,
	\`cost\` text NOT NULL,
	\`value\` text NOT NULL,
	\`isKnownPeriodEndPrice\` integer NOT NULL,
	FOREIGN KEY (\`accountingPeriodId\`) REFERENCES \`accountingPeriod\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
--> statement-breakpoint
INSERT INTO \`__new_assetValue\`("accountingPeriodId", "asset", "type", "amount", "cost", "value", "isKnownPeriodEndPrice") SELECT "accountingPeriodId", "asset", "type", "amount", "cost", "value", "isKnownPeriodEndPrice" FROM \`assetValue\`;--> statement-breakpoint
DROP TABLE \`assetValue\`;--> statement-breakpoint
ALTER TABLE \`__new_assetValue\` RENAME TO \`assetValue\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`assetValue_accountingPeriodId_asset_type_unique\` ON \`assetValue\` (\`accountingPeriodId\`,\`asset\`,\`type\`);--> statement-breakpoint
CREATE TABLE \`__new_crossActionBundleRelation\` (
	\`crossActionBundleId\` integer NOT NULL,
	\`actionId\` text NOT NULL,
	FOREIGN KEY (\`crossActionBundleId\`) REFERENCES \`crossActionBundle\`(\`id\`) ON UPDATE no action ON DELETE cascade,
	FOREIGN KEY (\`actionId\`) REFERENCES \`action\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
--> statement-breakpoint
INSERT INTO \`__new_crossActionBundleRelation\`("crossActionBundleId", "actionId") SELECT "crossActionBundleId", "actionId" FROM \`crossActionBundleRelation\`;--> statement-breakpoint
DROP TABLE \`crossActionBundleRelation\`;--> statement-breakpoint
ALTER TABLE \`__new_crossActionBundleRelation\` RENAME TO \`crossActionBundleRelation\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_crossActionBundleRelation\` ON \`crossActionBundleRelation\` (\`crossActionBundleId\`,\`actionId\`);--> statement-breakpoint
CREATE INDEX \`idx_crossActionBundleRelation_actionId\` ON \`crossActionBundleRelation\` (\`actionId\`);--> statement-breakpoint
CREATE TABLE \`__new_crossActionBundle\` (
	\`id\` integer PRIMARY KEY AUTOINCREMENT NOT NULL,
	\`accountingPeriodId\` integer NOT NULL,
	\`crossActionBundleId\` text NOT NULL,
	FOREIGN KEY (\`accountingPeriodId\`) REFERENCES \`accountingPeriod\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
--> statement-breakpoint
INSERT INTO \`__new_crossActionBundle\`("id", "accountingPeriodId", "crossActionBundleId") SELECT "id", "accountingPeriodId", "crossActionBundleId" FROM \`crossActionBundle\`;--> statement-breakpoint
DROP TABLE \`crossActionBundle\`;--> statement-breakpoint
ALTER TABLE \`__new_crossActionBundle\` RENAME TO \`crossActionBundle\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_crossActionBundle\` ON \`crossActionBundle\` (\`accountingPeriodId\`,\`crossActionBundleId\`);--> statement-breakpoint
CREATE TABLE \`__new_loanBorrow\` (
	\`loanId\` integer NOT NULL,
	\`key\` text NOT NULL,
	\`order\` integer NOT NULL,
	\`cryptoId\` text,
	\`nftId\` text,
	\`amount\` text NOT NULL,
	FOREIGN KEY (\`loanId\`) REFERENCES \`loan\`(\`id\`) ON UPDATE no action ON DELETE cascade,
	FOREIGN KEY (\`cryptoId\`) REFERENCES \`cryptoCurrency\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`nftId\`) REFERENCES \`nft\`(\`id\`) ON UPDATE no action ON DELETE no action
);
--> statement-breakpoint
INSERT INTO \`__new_loanBorrow\`("loanId", "key", "order", "cryptoId", "nftId", "amount") SELECT "loanId", "key", "order", "cryptoId", "nftId", "amount" FROM \`loanBorrow\`;--> statement-breakpoint
DROP TABLE \`loanBorrow\`;--> statement-breakpoint
ALTER TABLE \`__new_loanBorrow\` RENAME TO \`loanBorrow\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_loanBorrowPosition\` ON \`loanBorrow\` (\`loanId\`,\`key\`,\`order\`);--> statement-breakpoint
CREATE TABLE \`__new_loanBorrowWithDebtPosition\` (
	\`loanId\` integer NOT NULL,
	\`debtKey\` text NOT NULL,
	\`debtOrder\` integer NOT NULL,
	\`positionOrder\` integer NOT NULL,
	\`cryptoId\` text,
	\`nftId\` text,
	\`amount\` text NOT NULL,
	FOREIGN KEY (\`loanId\`) REFERENCES \`loan\`(\`id\`) ON UPDATE no action ON DELETE cascade,
	FOREIGN KEY (\`cryptoId\`) REFERENCES \`cryptoCurrency\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`nftId\`) REFERENCES \`nft\`(\`id\`) ON UPDATE no action ON DELETE no action
);
--> statement-breakpoint
INSERT INTO \`__new_loanBorrowWithDebtPosition\`("loanId", "debtKey", "debtOrder", "positionOrder", "cryptoId", "nftId", "amount") SELECT "loanId", "debtKey", "debtOrder", "positionOrder", "cryptoId", "nftId", "amount" FROM \`loanBorrowWithDebtPosition\`;--> statement-breakpoint
DROP TABLE \`loanBorrowWithDebtPosition\`;--> statement-breakpoint
ALTER TABLE \`__new_loanBorrowWithDebtPosition\` RENAME TO \`loanBorrowWithDebtPosition\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_loanBorrowWithDebtPosition\` ON \`loanBorrowWithDebtPosition\` (\`loanId\`,\`debtKey\`,\`debtOrder\`,\`positionOrder\`);--> statement-breakpoint
CREATE TABLE \`__new_loanBorrowWithDebt\` (
	\`loanId\` integer NOT NULL,
	\`key\` text NOT NULL,
	\`order\` integer NOT NULL,
	\`cryptoId\` text,
	\`nftId\` text,
	\`amount\` text NOT NULL,
	FOREIGN KEY (\`loanId\`) REFERENCES \`loan\`(\`id\`) ON UPDATE no action ON DELETE cascade,
	FOREIGN KEY (\`cryptoId\`) REFERENCES \`cryptoCurrency\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`nftId\`) REFERENCES \`nft\`(\`id\`) ON UPDATE no action ON DELETE no action
);
--> statement-breakpoint
INSERT INTO \`__new_loanBorrowWithDebt\`("loanId", "key", "order", "cryptoId", "nftId", "amount") SELECT "loanId", "key", "order", "cryptoId", "nftId", "amount" FROM \`loanBorrowWithDebt\`;--> statement-breakpoint
DROP TABLE \`loanBorrowWithDebt\`;--> statement-breakpoint
ALTER TABLE \`__new_loanBorrowWithDebt\` RENAME TO \`loanBorrowWithDebt\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_loanBorrowWithDebt\` ON \`loanBorrowWithDebt\` (\`loanId\`,\`key\`,\`order\`);--> statement-breakpoint
CREATE TABLE \`__new_loanDeposit\` (
	\`loanId\` integer NOT NULL,
	\`key\` text NOT NULL,
	\`order\` integer NOT NULL,
	\`cryptoId\` text,
	\`nftId\` text,
	\`amount\` text NOT NULL,
	FOREIGN KEY (\`loanId\`) REFERENCES \`loan\`(\`id\`) ON UPDATE no action ON DELETE cascade,
	FOREIGN KEY (\`cryptoId\`) REFERENCES \`cryptoCurrency\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`nftId\`) REFERENCES \`nft\`(\`id\`) ON UPDATE no action ON DELETE no action
);
--> statement-breakpoint
INSERT INTO \`__new_loanDeposit\`("loanId", "key", "order", "cryptoId", "nftId", "amount") SELECT "loanId", "key", "order", "cryptoId", "nftId", "amount" FROM \`loanDeposit\`;--> statement-breakpoint
DROP TABLE \`loanDeposit\`;--> statement-breakpoint
ALTER TABLE \`__new_loanDeposit\` RENAME TO \`loanDeposit\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_loanDeposit\` ON \`loanDeposit\` (\`loanId\`,\`key\`,\`order\`);--> statement-breakpoint
CREATE TABLE \`__new_loanDepositWithBondPosition\` (
	\`loanId\` integer NOT NULL,
	\`bondKey\` text NOT NULL,
	\`bondOrder\` integer NOT NULL,
	\`positionOrder\` integer NOT NULL,
	\`cryptoId\` text,
	\`nftId\` text,
	\`amount\` text NOT NULL,
	FOREIGN KEY (\`loanId\`) REFERENCES \`loan\`(\`id\`) ON UPDATE no action ON DELETE cascade,
	FOREIGN KEY (\`cryptoId\`) REFERENCES \`cryptoCurrency\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`nftId\`) REFERENCES \`nft\`(\`id\`) ON UPDATE no action ON DELETE no action
);
--> statement-breakpoint
INSERT INTO \`__new_loanDepositWithBondPosition\`("loanId", "bondKey", "bondOrder", "positionOrder", "cryptoId", "nftId", "amount") SELECT "loanId", "bondKey", "bondOrder", "positionOrder", "cryptoId", "nftId", "amount" FROM \`loanDepositWithBondPosition\`;--> statement-breakpoint
DROP TABLE \`loanDepositWithBondPosition\`;--> statement-breakpoint
ALTER TABLE \`__new_loanDepositWithBondPosition\` RENAME TO \`loanDepositWithBondPosition\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_loanDepositWithBondPosition\` ON \`loanDepositWithBondPosition\` (\`loanId\`,\`bondKey\`,\`bondOrder\`,\`positionOrder\`);--> statement-breakpoint
CREATE TABLE \`__new_loanDepositWithBond\` (
	\`loanId\` integer NOT NULL,
	\`key\` text NOT NULL,
	\`order\` integer NOT NULL,
	\`cryptoId\` text,
	\`nftId\` text,
	\`amount\` text NOT NULL,
	FOREIGN KEY (\`loanId\`) REFERENCES \`loan\`(\`id\`) ON UPDATE no action ON DELETE cascade,
	FOREIGN KEY (\`cryptoId\`) REFERENCES \`cryptoCurrency\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`nftId\`) REFERENCES \`nft\`(\`id\`) ON UPDATE no action ON DELETE no action
);
--> statement-breakpoint
INSERT INTO \`__new_loanDepositWithBond\`("loanId", "key", "order", "cryptoId", "nftId", "amount") SELECT "loanId", "key", "order", "cryptoId", "nftId", "amount" FROM \`loanDepositWithBond\`;--> statement-breakpoint
DROP TABLE \`loanDepositWithBond\`;--> statement-breakpoint
ALTER TABLE \`__new_loanDepositWithBond\` RENAME TO \`loanDepositWithBond\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_loanDepositWithBond\` ON \`loanDepositWithBond\` (\`loanId\`,\`key\`,\`order\`);--> statement-breakpoint
CREATE TABLE \`__new_loan\` (
	\`id\` integer PRIMARY KEY AUTOINCREMENT NOT NULL,
	\`accountingPeriodId\` integer NOT NULL,
	\`loanId\` text NOT NULL,
	FOREIGN KEY (\`accountingPeriodId\`) REFERENCES \`accountingPeriod\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
--> statement-breakpoint
INSERT INTO \`__new_loan\`("id", "accountingPeriodId", "loanId") SELECT "id", "accountingPeriodId", "loanId" FROM \`loan\`;--> statement-breakpoint
DROP TABLE \`loan\`;--> statement-breakpoint
ALTER TABLE \`__new_loan\` RENAME TO \`loan\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_loan\` ON \`loan\` (\`accountingPeriodId\`,\`loanId\`);--> statement-breakpoint
CREATE INDEX \`idx_loan_accountingPeriodId\` ON \`loan\` (\`accountingPeriodId\`);--> statement-breakpoint
CREATE TABLE \`__new_solanaTokenAccount\` (
	\`accountId\` integer NOT NULL,
	\`address\` text NOT NULL,
	FOREIGN KEY (\`accountId\`) REFERENCES \`account\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
--> statement-breakpoint
INSERT INTO \`__new_solanaTokenAccount\`("accountId", "address") SELECT "accountId", "address" FROM \`solanaTokenAccount\`;--> statement-breakpoint
DROP TABLE \`solanaTokenAccount\`;--> statement-breakpoint
ALTER TABLE \`__new_solanaTokenAccount\` RENAME TO \`solanaTokenAccount\`;--> statement-breakpoint
CREATE UNIQUE INDEX \`idx_solanaTokenAccount\` ON \`solanaTokenAccount\` (\`accountId\`,\`address\`);--> statement-breakpoint
PRAGMA foreign_keys=ON;--> statement-breakpoint
CREATE TABLE \`accountApiLost\` (
	\`id\` integer PRIMARY KEY AUTOINCREMENT NOT NULL,
	\`apiId\` integer NOT NULL,
	\`from\` integer NOT NULL,
	\`to\` integer NOT NULL,
	FOREIGN KEY (\`apiId\`) REFERENCES \`accountApi\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
--> statement-breakpoint
CREATE INDEX \`unq_accountApiLost_apiId\` ON \`accountApiLost\` (\`apiId\`);--> statement-breakpoint
CREATE TABLE \`accountApiPending\` (
	\`id\` integer PRIMARY KEY AUTOINCREMENT NOT NULL,
	\`apiId\` integer NOT NULL,
	\`from\` integer NOT NULL,
	\`to\` integer NOT NULL,
	FOREIGN KEY (\`apiId\`) REFERENCES \`accountApi\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
--> statement-breakpoint
CREATE INDEX \`unq_accountApiPending_apiId\` ON \`accountApiPending\` (\`apiId\`);--> statement-breakpoint
CREATE TABLE \`accountApi\` (
	\`id\` integer PRIMARY KEY AUTOINCREMENT NOT NULL,
	\`accountId\` integer NOT NULL,
	\`subType\` text,
	\`type\` text NOT NULL,
	\`from\` integer,
	\`to\` integer,
	FOREIGN KEY (\`accountId\`) REFERENCES \`account\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
--> statement-breakpoint
CREATE UNIQUE INDEX \`unq_accountApi\` ON \`accountApi\` (\`accountId\`,\`type\`,\`subType\`);--> statement-breakpoint
ALTER TABLE \`action\` ADD \`apiId\` integer REFERENCES accountApi(id);--> statement-breakpoint
CREATE INDEX \`idx_action_apiId\` ON \`action\` (\`apiId\`);--> statement-breakpoint
ALTER TABLE \`accountApi\` ADD \`stopped\` integer;--> statement-breakpoint
ALTER TABLE \`account\` ADD \`apiStartTime\` integer;`
